<template>
  <div>
    <b-row align-v="center" align-h="center" no-gutters class=" mt-5 mb-5">
      <template v-if="kudo">
        <b-col cols="auto">
          <kudo-item :kudo="kudo" :selectable="true" :selected="true" style="max-width:6rem;" />
        </b-col>
        <b-col cols="auto" class="px-3">
          <b-icon-caret-right-fill font-scale="3" />
        </b-col>
      </template>
      <b-col cols="auto">
        <div style="max-width:6rem;">
          <div>
            <avatar :src="photo" size="6rem" />
          </div>
          <div class="text-center font-weight-bold mt-2">
            {{name}}
          </div>
        </div>
      </b-col>
    </b-row>
    <give-kudo-form
      v-if="!isKudosLoading"
      :receiver="receiver"
      :receiver-type="receiverType"
      :giver="profileMe"
      :kudos="kudos"
      :received="received"
      :submitting="submitting"
      @select-kudo="onKudoSelect"
      @submit="onGiveKudoSubmit"
    />
    <div v-else class="text-center p-5">
      <b-spinner variant="primary" label="Loading..." />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BIconCaretRightFill } from 'bootstrap-vue'
import Avatar from '@/components/common/Avatar'
import GiveKudoForm from '@/components/forms/GiveKudoForm.vue'
import { KudoItem } from '@/components/KudosList'
import { RECEIVER_TYPE } from '@/helpers/types'
import { toastError, userName } from '@/helpers/helpers'

export default {
  name: 'GiveKudo',

  props: {
    receiver: {
      type: Object,
      required: true
    },

    receiverType: {
      type: String,
      required: true,
      validator(value) {
        return Object.values(RECEIVER_TYPE).indexOf(value) !== -1
      }
    }
  },

  computed: {
    ...mapGetters([
      'profileMe',
      'isKudosLoading',
      'isUserKudosLoading',
      'kudos',
      'meKudosReceived'
    ]),

    received() {
      return this.isUserKudosLoading ? undefined : this.meKudosReceived()
    },

    photo() {
      return this.receiver.photo
    },
    name() {
      return this.receiverType === RECEIVER_TYPE.USER
        ? userName(this.receiver)
        : this.receiver.name
    }
  },

  data() {
    return {
      kudo: null,
      submitting: false
    }
  },

  mounted() {
    this.$store.dispatch('fetchKudosIfNot')
    this.$store.dispatch('fetchMeKudos')
  },

  methods: {
    onKudoSelect(id) {
      this.kudo = this.kudos.find(kudo => kudo.id === id)
    },

    onGiveKudoSubmit(data) {
      this.submitting = true
      this.$store.dispatch('sendKudo', data)
        .then(() => this.$emit('submitted'))
        .catch(() => toastError(this))
        .finally(() => { this.submitting = false })
    }
  },

  components: {
    Avatar,
    KudoItem,
    GiveKudoForm,
    BIconCaretRightFill
  }
}
</script>
